<template lang="pug">
v-content
  v-toolbar.page-header(app, flat, fixed, color='white', height='105')
    v-breadcrumbs(divider='/')
      v-breadcrumbs-item
        h2 All Organizations
    v-spacer
    v-btn.page-header__action(to='/organizations/add', exact='', color='primary') Add

  v-container.pa-0(fluid, grid-list-lg)
    v-layout(:row='$vuetify.breakpoint.smAndUp', :column='$vuetify.breakpoint.smAndDown', nowrap)
      v-flex.content--main.pr-4
        v-data-table(v-bind:headers='headers', v-bind:items='items', v-bind:search='search', hide-actions)
          template(slot='items', slot-scope='props')
            td(width='40%')
              router-link(:to="`/organizations/organization/${props.item.id}`")
                | {{ props.item.name }}
            td
              | {{ props.item.inventions_amount }}
            td
              | {{ props.item.submissions_amount }}
            td
              | {{ props.item.inventors_amount }}
            td
              | {{ props.item.admins_amount }}

      v-flex(style='position: relative; flex: 0 0 236px')
        .d-block.pt-4(style='width: 220px; position: fixed')
          .body-1.mb-0(style='position: absolute;top: 10px')
            | Search:
          v-text-field.input--box(append-icon='search', label='Search', single-line, hide-details, v-model='search', clearable)

</template>

<script>
  import tools from '../../assets/tools.js'

  export default {
    data () {
      return {
        max25chars: (v) => v.length <= 25 || 'Input too long!',
        tmp: '',
        search: '',
        pagination: {},
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name'
          },
          {
            text: 'Invention Opportunities',
            align: 'left',
            value: 'inventions_amount'
          },
          {
            text: 'Submissions',
            align: 'left',
            value: 'submissions_amount'
          },
          {
            text: 'Inventors',
            align: 'left',
            value: 'inventors_amount'
          },
          {
            text: 'Admins',
            align: 'left',
            value: 'admins_amount'
          }
        ],
        items: []
      }
    },
    created () {
      var component = this

      tools.getOrganizationsList({
        success: function (organizationList) {
          for (var i = 0; i < organizationList.length; i++) {
            var targetOrganization = organizationList[i] || {}

            component.items.push({
              id: targetOrganization.id,
              name: targetOrganization.name,
              summary: targetOrganization.summary,
              time_zone: targetOrganization.time_zone,
              inventions_amount: targetOrganization.inventions_amount,
              submissions_amount: targetOrganization.submissions_amount,
              inventors_amount: targetOrganization.inventors_amount,
              admins_amount: targetOrganization.admins_amount
            })
          }
        }
      })
    }
  }
</script>


<style scoped>
.side-drawer {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/Organizations/Organizations.vue